// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2619G","signatureButtonsRight":"ModalSign_signatureButtonsRight__1sbjm"};